import { Box, Typography } from "@mui/material";
import { createStyles, palette } from "../../../styles/theme";

const styles = createStyles({
  displayCellButton: {
    minHeight: 45,
    height: 45,
    minWidth: 88,
    px: 0.75,
    py: 0.25,
    borderRadius: 0.75,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      bgcolor: palette.grey.lightBackground,
    },
  },
  displayCellText: {
    fontSize: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  mutedText: {
    color: "text.secondary",
  },
});

export function CompactDisplayCheckboxCell({
  checked,
  onClick,
  minWidth,
  maxWidth,
}: {
  checked: boolean;
  onClick?: () => void;
  minWidth?: number;
  maxWidth?: number;
}) {
  return (
    <Box
      onClick={onClick}
      sx={{
        ...styles.displayCellButton,
        ...(minWidth ? { minWidth } : null),
        ...(maxWidth ? { maxWidth, width: "100%" } : null),
      }}
    >
      <Typography
        variant="body2"
        sx={{
          ...styles.displayCellText,
          ...(checked ? null : styles.mutedText),
        }}
      >
        {checked ? "Yes" : "No"}
      </Typography>
    </Box>
  );
}
